var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 26.2979C0 11.774 11.774 0 26.2979 0C40.8218 0 52.5957 11.774 52.5957 26.2979C52.5957 40.8218 40.8218 52.5957 26.2979 52.5957C11.774 52.5957 0 40.8218 0 26.2979Z",
    fill: "#C6A75E",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.108 27.2731L31.768 36.6154C31.7866 36.7254 31.7712 36.8385 31.7238 36.9395C31.6764 37.0405 31.5993 37.1246 31.5028 37.1806C31.4063 37.2366 31.295 37.2618 31.1838 37.2528C31.0726 37.2438 30.9668 37.2011 30.8805 37.1304L26.9577 34.1861C26.7684 34.0446 26.5383 33.9682 26.3019 33.9682C26.0655 33.9682 25.8355 34.0446 25.6461 34.1861L21.7168 37.1293C21.6306 37.1999 21.5249 37.2425 21.4138 37.2515C21.3027 37.2605 21.1916 37.2354 21.0951 37.1796C20.9987 37.1237 20.9216 37.0398 20.8741 36.939C20.8266 36.8382 20.8109 36.7253 20.8292 36.6154L22.4882 27.2731",
    stroke: "#C6A75E",
    strokeWidth: 2.19149,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2976 28.4893C29.9286 28.4893 32.8721 25.5458 32.8721 21.9148C32.8721 18.2838 29.9286 15.3403 26.2976 15.3403C22.6666 15.3403 19.7231 18.2838 19.7231 21.9148C19.7231 25.5458 22.6666 28.4893 26.2976 28.4893Z",
    stroke: "#C6A75E",
    strokeWidth: 2.19149,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.6999d1b017bee518ac2c231bf646a364.svg";
export { ForwardRef as ReactComponent };